<template>
    <div>
        <div>
            <div>
                <div style="display: flex;justify-content: flex-start">
                    <el-select v-model="searchValue.productCategoryId" clearable placeholder="产品分类">
                        <el-option
                                v-for="item in productCategorys"
                                :key="item.productCategoryId"
                                :label="item.productCategoryName"
                                :value="item.productCategoryId">
                        </el-option>
                    </el-select>
                    <el-input placeholder="批次编号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductBatchs"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productBatchId"
                              @keydown.enter.native="initProductBatchs"></el-input>
                    <el-input placeholder="产品编号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductBatchs"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productId"
                              @keydown.enter.native="initProductBatchs"></el-input>
                    <el-input placeholder="产品代码" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductBatchs"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productCode"
                              @keydown.enter.native="initProductBatchs"></el-input>
                    <el-input placeholder="批次标题" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProductBatchs"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productBatchTitle"
                              @keydown.enter.native="initProductBatchs"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initProductBatchs"
                               style="margin-left: 10px">
                        搜索
                    </el-button>
                </div>
                <div style="display: flex;justify-content: flex-start; margin-top: 10px">
                    <el-button type="primary" icon="el-icon-plus" @click="showAddProductBatchView">
                        新增批次
                    </el-button>
                    <el-button icon="el-icon-upload2" @click="goTracingTemplate">
                        新增追溯
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    ref="productBatchTable"
                    :data="productBatchs"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    style="width: 100%">
                <el-table-column
                        prop="productBatchId"
                        align="center"
                        label="批次编号"
                        min-width="7%">
                </el-table-column>
                <el-table-column
                        prop="productBatchTitle"
                        label="批次标题"
                        align="center"
                        min-width="10%">
                </el-table-column>
                <el-table-column
                        prop="productBatchDate"
                        min-width="12%"
                        align="center"
                        :formatter="formatDate"
                        label="批次日期">
                </el-table-column>
                <el-table-column
                        prop="productId"
                        label="产品编号"
                        align="center"
                        min-width="8%">
                </el-table-column>
                <el-table-column
                        prop="productCode"
                        label="产品代码"
                        align="center"
                        min-width="20%">
                </el-table-column>
                <el-table-column
                        prop="productName"
                        label="产品名称"
                        min-width="10%"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="productBatchMemo"
                        label="批次说明"
                        min-width="8%"
                        align="center">
                </el-table-column>
                <el-table-column
                        min-width="15%"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="showAddTracingView(scope.row)" style="padding: 3px" size="mini">追溯</el-button>
                        <el-button type="success" @click="showUpdateProductBatchView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button type="danger" @click="deleteProductBatch(scope.row)" style="padding: 3px" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
            <div style="padding: 25px">
                <div class="templateBottom">
                    <p style="height: 8px">说明:</p>
                    <p style="height: 5px">1.</p>
                    <p style="height: 5px">2.</p>
                    <p style="height: 5px">3.</p>
                </div>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogAddVisible"
                width="80%">
            <div>
                <el-form :model="productBatch" :rules="rules" ref="productBatchAddForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="批次标题:" prop="productBatchTitle">
                            <el-input size="mini" style="width: 300px" prefix-icon="el-icon-edit" v-model="productBatch.productBatchTitle"
                                      placeholder="请输入批次标题"></el-input>
                        </el-form-item>
                        <el-form-item label="批次日期:" prop="productBatchDate" style="width: 300px; padding-left: 50px">
                            <el-date-picker
                                    v-model="productBatch.productBatchDate"
                                    type="date"
                                    value-format="yyyyMMdd"
                                    placeholder="请选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品名称:" style="width: 350px" prop="productId">
                            <el-select v-model="productBatch.productId" clearable placeholder="请选择产品">
                                <el-option
                                        v-for="item in products"
                                        :key="item.productId"
                                        :label="item.productName"
                                        :value="item.productId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="批次说明:" prop="productBatchMemo" style="padding-left: 10px">
                            <el-input size="mini" type="textarea" style="width: 300px" prefix-icon="el-icon-edit" v-model="productBatch.productBatchMemo"
                                      placeholder="请输入批次说明"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProductBatch(productBatch)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogUpdateVisible"
                width="80%">
            <div>
                <el-form :model="productBatch" :rules="rules" ref="productBatchUpdateForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品名称:" prop="productId">
                            <el-select v-model="productBatch.productId" clearable placeholder="请选择产品">
                                <el-option
                                        v-for="item in products"
                                        :key="item.productId"
                                        :label="item.productName"
                                        :value="item.productId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="批次标题:" prop="productBatchTitle" style="padding-left: 50px">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="productBatch.productBatchTitle"
                                      placeholder="请输入批次标题"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="批次日期:" prop="productBatchDate">
                            <el-date-picker
                                    v-model="productBatch.productBatchDate"
                                    type="date"
                                    value-format="yyyyMMdd"
                                    placeholder="请选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="批次说明:" prop="productBatchMemo" style="padding-left: 50px">
                            <el-input size="mini" type="textarea" style="width: 150px" prefix-icon="el-icon-edit" v-model="productBatch.productBatchMemo"
                                      placeholder="请输入批次说明"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateProductBatch(productBatch)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "ProductBatch",
        inject: ['reload'],
        data() {
            return {
                searchValue: {
                    productCategoryId: null,
                    productBatchId: null,
                    productId: null,
                    productCode: '',
                    productBatchTitle: ''
                },
                title: '',
                products: [],
                productCategorys: [],
                productBatchs: [],
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                action: '',
                dialogAddVisible: false,
                dialogUpdateVisible: false,
                dialogTracingVisible: false,
                productBatch: {
                    productCategoryId: null,
                    productBatchId: null,
                    productId: null,
                    productCode: '',
                    productBatchTitle: '',
                    productBatchDate: '',
                    productBatchMemo: ''
                },
                rules: {
                    productBatchTitle: [{required: true, message: '请输入批次标题', trigger: 'blur'}],
                    productBatchDate: [{required: true, message: '请选择批次日期', trigger: 'blur'}],
                    productId: [{required: true, message: '请选择产品', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.getProductCategorys();
            this.initProductBatchs();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initProductBatchs();//获取列表数据
                }
            }
        },
        methods: {
            formatDate(row, column) {
                // 获取单元格数据
                let productBatchDate = row.productBatchDate;
                if(productBatchDate == null) {
                    return '';
                }
                const pattern = /(\d{4})(\d{2})(\d{2})/;
                let date = new Date(productBatchDate.replace(pattern, '$1-$2-$3'));
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                return Y+M+D;
            },
            goTracingTemplate() {
                this.$router.push('/product/product');
                // this.$router.push('/tracing/template');
            },
            getProductCategorys() {
                this.getRequest('/product/category/list').then(resp => {
                    if (resp) {
                        this.productCategorys = resp.data;
                    }
                });
            },
            getProducts() {
                this.getRequest('/product/product/list').then(resp => {
                    if (resp) {
                        this.products = resp.data;
                    }
                });
            },
            showAddProductBatchView() {
                this.title = '添加产品批次信息';
                this.emptyProductBatch();
                this.getProducts();
                this.dialogAddVisible = true;
            },
            showUpdateProductBatchView(data) {
                this.title = '编辑产品批次信息';
                this.emptyProductBatch();
                this.getProducts();
                this.productBatch = data;
                this.dialogUpdateVisible = true;
            },
            showAddTracingView(data) {
                this.title = '溯源信息';
                this.emptyProductBatch();
                this.productBatch = data;
                this.dialogTracingVisible = true;
            },
            addProductBatch(productBatch) {
                if(productBatch){
                    this.$refs['productBatchAddForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/product/batch/add", productBatch).then(resp => {
                                if (resp) {
                                    this.dialogAddVisible = false;
                                    this.initProductBatchs();
                                }
                            })
                        }
                    });
                }
            },
            updateProductBatch(productBatch) {
                if(productBatch){
                    this.$refs['productBatchUpdateForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/product/batch/update", productBatch).then(resp => {
                                if (resp) {
                                    this.dialogUpdateVisible = false;
                                    this.initProductBatchs();
                                }
                            })
                        }
                    });
                }
            },
            deleteProductBatch(data) {
                this.$confirm('此操作将永久删除【' + data.productBatchTitle + '】批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/product/batch/delete", data).then(resp => {
                        if (resp) {
                            this.initProductBatchs();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            emptyProductBatch() {
                this.productBatch = {
                    productCategoryId: null,
                    productBatchId: null,
                    productId: null,
                    productCode: '',
                    productBatchTitle: '',
                    productBatchDate: '',
                    productBatchMemo: ''
                }
            },
            initProductBatchs() {
                this.loading = true;
                let url = '/product/batch/listByPage?page=' + this.page + '&size=' + this.size;
                if (this.searchValue.productCategoryId) {
                    url += '&productCategoryId=' + this.searchValue.productCategoryId;
                }
                if (this.searchValue.productBatchId) {
                    url += '&productBatchId=' + this.searchValue.productBatchId;
                }
                if (this.searchValue.productId) {
                    url += '&productId=' + this.searchValue.productId;
                }
                if (this.searchValue.productCode) {
                    url += '&productCode=' + this.searchValue.productCode;
                }
                if (this.searchValue.productBatchTitle) {
                    url += '&productBatchTitle=' + this.searchValue.productBatchTitle;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.productBatchs = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initProductBatchs();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initProductBatchs();
            }
        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .templateBottom {
        padding: 10px;
        background-color: #FFFFE0;
        box-sizing: border-box;
    }

    .templateType{
        margin-top: 8px;
    }

    .templateUpload{
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content:center
    }

    .hide .el-upload--picture-card {
        display: none;
    }

</style>